export default __webpack_public_path__ + "static/media/54B7799C-00.fb1a9829.png";